export async function turboConfirmMethod(title, element, submitter) {
  let originalElement = submitter

  if (!submitter) {
    let matchingElements = document.querySelectorAll(`a[data-turbo-confirm="${title}"][data-turbo-method="${element.getAttribute('method')}"]`)
    originalElement = [...matchingElements].find((el) => element.action.includes(el.href))
  }

  const confirmModal = document.querySelector('.design-system-modal-confirm-component')

  const showEvent = new CustomEvent("show", {
    detail: {
      confirmTitle: title,
      confirmMessage: originalElement.dataset.confirmMessage,
      confirmButtonTitle: originalElement.dataset.confirmButtonTitle,
      cancelButtonTitle: originalElement.dataset.cancelButtonTitle
    }
  })

  confirmModal.dispatchEvent(showEvent)

  return new Promise((resolve) => {
    confirmModal.addEventListener("design-system--modal-confirm-component:cancel", () => resolve(false), { once: true })
    confirmModal.addEventListener("design-system--modal-confirm-component:confirm", () => resolve(true), { once: true })
  })
}
